import { useMemo } from "react";
import { inject } from "../ng";
import { Guide } from "./guide/guide";
import { InteractionModes } from "./interaction-modes";
import classes from "./map-nav.module.css";
import { MapStyles } from "./map-styles";
import { NavHistory } from "./nav-history";
import { zoomToCurrentLocation } from "./utils";

export function MapNav() {
	const { zoomIn, zoomOut } = useMemo(() => {
		const map = inject("mapService").getMap();
		return {
			zoomIn() {
				map.zoomIn();
			},
			zoomOut() {
				map.zoomOut();
			},
		};
	}, []);

	return (
		<div className={classes.nav}>
			<div className={classes.section}>
				<button
					title="Zoom In"
					type="button"
					className={classes.button}
					onClick={zoomIn}
				>
					<i className="ico ico-plus" />
				</button>
				<button
					title="Zoom Out"
					type="button"
					className={classes.button}
					onClick={zoomOut}
				>
					<i className="ico ico-minus" />
				</button>
				<button
					title="Zoom to Current Location"
					type="button"
					className={classes.button}
					onClick={zoomToCurrentLocation}
				>
					<i className="ico ico-location-arrow" />
				</button>
			</div>
			<div className={classes.section}>
				<MapStyles />
				<Guide />
			</div>
			<InteractionModes />
			<NavHistory />
		</div>
	);
}
